export const baseWidth = 375;

export const scaledValue = (width: number | undefined, value: number) => {
  if (!width) {
    return value;
  }
  const scale = width / baseWidth;
  return Math.round(scale * value);
};
